import { render, staticRenderFns } from "./drawer_check.vue?vue&type=template&id=22fbb4ca&scoped=true&"
import script from "./drawer_check.vue?vue&type=script&lang=js&"
export * from "./drawer_check.vue?vue&type=script&lang=js&"
import style0 from "./drawer_check.vue?vue&type=style&index=0&id=22fbb4ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbb4ca",
  null
  
)

export default component.exports